

import Pulse from "react-reveal/Pulse";
import Zoom from 'react-reveal/Zoom';


import "./styles.css";

function Services() {

  return (
    <section id="services" class="services-mf  route px-5">
    
    
        <div class="container px-5">
          <div class="row">
            <div class="col-sm-12">
              <div className="section-title">
                <h2>Services</h2>
                <p>
                  I offer the Best <b>Development</b> Service to customers,
                  according to their requirement.
                </p>
              </div>
            </div>
          </div>
          <div class="row px-2">
      
            <div class="col-md-4">
              <div class="service-box">
                <div class="service-ico">
                  <span class="ico-circle">
                    <i class="bi bi-briefcase"></i>
                  </span>
                </div>
                <div class="service-content">
                  <Pulse>
                    <h2 class="s-title">Web Design</h2>
                  </Pulse>
                  <Zoom left> 
                    <p class="s-description text-center">
                      I develop web applications using the latest Web Design.
                    </p>
                  </Zoom>
                </div>
              </div>
            </div>{" "}
            <div class="col-md-4">
              <div class="service-box">
                <div class="service-ico">
                  <span class="ico-circle">
                    <i class="bi bi-card-checklist"></i>
                  </span>
                </div>
                <div class="service-content">
                  <Pulse>
                    <h2 class="s-title">Web Development</h2>
                  </Pulse>
                  <Zoom left>
                    <p class="s-description text-center">
                      I develop web applications using the latest front-end
                      technologies.
                    </p>
                  </Zoom>
                </div>
              </div>
            </div>{" "}
            <div class="col-md-4">
              <div class="service-box">
                <div class="service-ico">
                  <span class="ico-circle">
                    <i class="bi bi-binoculars"></i>
                  </span>
                </div>
                <div class="service-content">
                  <Pulse>
                    <h2 class="s-title">Responsive Design</h2>
                  </Pulse>
                  <Zoom left>
                    <p class="s-description text-center">
                      I develop web applications using the latest Responsive
                      Design.
                    </p>
                  </Zoom>
                </div>
              </div>
            </div>{" "}
            <div class="col-md-4">
              <div class="service-box">
                <div class="service-ico">
                  <span class="ico-circle">
                    <i class="bi bi-calendar4-week"></i>
                  </span>
                </div>
                <div class="service-content">
                  <Pulse>
                    {" "}
                    <h2 class="s-title">Back-end Development</h2>
                  </Pulse>
                  <Zoom left>
                    <p class="s-description text-center">
                      I specialize in providing high-quality backend services
                      for various businesses.
                    </p>
                  </Zoom>
                </div>
              </div>
            </div>
          </div>
        </div>
    
   
        </section>
    
  );
}

export default Services;
